export default {
  marketOptions: () => ({ skipFetch: true }),
  cardBodyClassNames: () => 'bet-builder',
};
